'use es6';

export default ((store, actionCreatorsList) => actionCreatorsList.map(creator => (...args) => store.dispatch(creator(...args))));